import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useSelector } from 'react-redux';
import { Link as RouterLink, NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { switchMode } from '../components/Theme/modeSlice';

const Search = styled('div')(({ theme }) => ({
  
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));


export default function Header() {
  const notifications = useSelector((state) => state.notifications.notifications);

  const dispatch = useDispatch();

  const toggleSidebar = () => {
    const event = new Event("toggleSideBar");
    window.dispatchEvent(event);
  }
  const user = useSelector((state) => state.user.user);
  const mode = useSelector((state) => state.mode.mode);

  return (
    <Box  sx={{ flexGrow: 1, position: 'fixed', zIndex: 1500, width: '100%', top: 0 }}>
      <AppBar position="static" color="inherit" sx={{ bgcolor: 'background.paper', color: 'text.primary', borderBottom: 1, borderColor: 'divider' }} enableColorOnDark>
        <Toolbar sx={{ minHeight: '64px !important', paddingX: { xs: '16px', sm: '24px' } }}>
          <img style={{height: "40px"}} alt="Trust Vault LLC" src={mode === 'light' ? '/images/logos/trust-vault-logo-dark.png' : '/images/logos/trust-vault-logo-light.png'} />
          <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 2, ml: 3, overflowX: 'auto' }}>
            {[
              ['/wallet', 'Wallet'],
              ['/swap-coin', 'Swap'],
              ['/plans', 'Invest'],
              ['/copy-plans', 'Copy Trade'],
              ['/connect-wallet', 'DApps'],
            ].map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                style={({ isActive }) => ({
                  color: isActive ? '#d946ef' : 'inherit',
                  opacity: isActive ? 1 : 0.72,
                  textDecoration: 'none',
                  fontSize: '14px',
                  whiteSpace: 'nowrap'
                })}
              >
                {label}
              </NavLink>
            ))}
          </Box>
         

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <IconButton
              onClick={() => dispatch(switchMode(mode === 'dark' ? 'light' : 'dark'))}
              aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
              sx={{ color: 'text.primary' }}
            >
              {mode === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
            </IconButton>

            <IconButton
              component={RouterLink}
              to="/notifications"
              aria-label="show notifications"
              sx={{ color: 'text.primary' }}
            >
              <Badge badgeContent={notifications.length || 0} color="error">
                <NotificationsNoneIcon />
              </Badge>
            </IconButton>

            <IconButton
              onClick={toggleSidebar}
              aria-label="open drawer"
              sx={{
                color: 'text.primary',
                width: 40,
                height: 40,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: '50%',
              }}
            >
              <Box sx={{ width: 16, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <Box sx={{ height: '1.5px', width: '100%', bgcolor: 'currentColor', borderRadius: 1 }} />
                <Box sx={{ height: '1.5px', width: '62%', ml: 'auto', bgcolor: 'currentColor', borderRadius: 1 }} />
              </Box>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
